import { createAppAsyncThunk } from '../store/extensions';
import {
  clearNotificationsBadgeCall,
  deleteNotificationCall,
  fetchNotificationsCall,
  readNotificationCall,
} from './service';

export const fetchNotifications = createAppAsyncThunk(
  'notification/getAll',
  (arg: { xMsContinuationToken?: string; numrecs?: number }) => {
    return fetchNotificationsCall(arg.xMsContinuationToken, arg.numrecs);
  }
);

export const deleteNotification = createAppAsyncThunk(
  'notification/delete',
  (arg: { notificationId: string; toMemberId: string }) => {
    return deleteNotificationCall(arg.notificationId, arg.toMemberId);
  }
);

export const readNotification = createAppAsyncThunk(
  'notification/read',
  (arg: { notificationId: string; toMemberId: string }) => {
    return readNotificationCall(arg.notificationId, arg.toMemberId);
  }
);

export const clearNotificationsBadge = createAppAsyncThunk(
  'notification/readAll',
  (notificationType?: string) => {
    return clearNotificationsBadgeCall(notificationType);
  }
);
